module.exports = __webpack_public_path__ + "bi.svg?0afee1825caad63e335dcc34c4ad6ec7";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bi.svg
// module id = 1199
// module chunks = 27